import { htmlClassName } from '@/helpers/html'
import { cn } from '@/lib/utils'

export default function AboutSection({ bio, availability }) {
  return (
    <div className="flex w-full flex-col gap-4 rounded bg-neutral-blue-700 p-8 xl:gap-10">
      <p className="text-center font-syncopate text-xl font-bold uppercase text-shades-0 xl:text-start xl:text-2xl">
        About me
      </p>

      <div
        className={cn(
          htmlClassName,
          'flex flex-col gap-8 text-center text-neutral-blue-200 xl:text-start',
        )}
      >
        {bio ? (
          <div dangerouslySetInnerHTML={{ __html: bio }} />
        ) : (
          <p className="flex h-36 items-center justify-center text-center text-xl text-shades-0">
            No about me set!
          </p>
        )}
      </div>

      {availability && availability.length > 0 && (
        <div className="flex flex-col gap-4">
          <p className="text-center font-syncopate text-xl font-bold uppercase text-shades-0 xl:text-start xl:text-2xl">
            Availability
          </p>
          <div className="flex flex-wrap justify-center gap-2 xl:justify-start">
            {availability.map((day) => (
              <span
                key={day}
                className="rounded bg-neutral-blue-900 px-3 py-1 font-semibold capitalize text-shades-0"
              >
                {day}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
